export const MAX_VOL = 64;
export const MIN_VOL = 0;
export const VOL_STEP = 8;
export const VERSION = "0.2.01";